import { styled } from '@mui/material/styles';
import { resolveMprcMargin } from "components/styles/resolvers";
import { CSSProperties } from "react";

////////////////////////////////////////////////////////////////////////////////

interface IContainerProps {
    id?: string;

    /**
     * Estilos.
     */
    style?: CSSProperties | undefined;

    /**
     * Margem para o próximo componente.
     * Se não definido, a margem 'normal' será aplicada.
     */
    margin?: MprcMargin;

    /**
     * Posição do Container.
     */
    position?: "sticky" | "relative" | "absolute" | "inherit";
}

const Container = styled(
    "div",
    {
        shouldForwardProp: (propName: string) => propName == "children" || propName == "id" || propName == "className"
    })<IContainerProps>(
        ({ theme, margin = "normal", position, style }) => ({
            ...style,
            position: position,

            display: position === "sticky" ? "flow-root" : undefined,
            top: position === "sticky" ? 0 : undefined,
            zIndex: position === "sticky" ? theme.zIndex.appBar : undefined,
            backgroundColor: position === "sticky" ? theme.extended.workArea.background.toString() : "inherit",

            paddingBottom: resolveMprcMargin(theme, margin),

            overflowY: (style?.height || style?.maxHeight) ? "auto" : undefined,
            overflowX: (style?.height || style?.maxHeight) ? "hidden" : undefined,
        })
    );

////////////////////////////////////////////////////////////////////////////////

interface IProps {
    children?: React.ReactNode;
}

type Props = IProps & IContainerProps;

/**
 * Container para alocar outros componentes.
 * @param props
 * @returns
 */
export const MprcContainer: React.FC<Props> = (props) => {
    const { children, position = "inherit", ...classProps } = props;

    return (
        <Container
            {...classProps}
            position={position}
            className="MprcContainer"
        >
            {children}
        </Container>
    );
};
